import { CTA } from "./CTA";
import { HeroFlowBackground } from "./HeroFlowBackground";

interface HeroProps {
  eyebrow?: string;
  title: string;
  subtitle: string;
  primaryCTA?: { label: string; to: string };
  secondaryCTA?: { label: string; to: string };
}

export function Hero({ eyebrow, title, subtitle, primaryCTA, secondaryCTA }: HeroProps) {
  return (
    <section
      className="section section-dark"
      style={{
        paddingTop: "var(--space-16)",
        paddingBottom: "var(--space-16)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <HeroFlowBackground />
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(90deg, rgba(10,22,40,0.78) 0%, rgba(10,22,40,0.5) 45%, rgba(10,22,40,0.25) 100%)",
        }}
        aria-hidden
      />
      <div className="container" style={{ position: "relative" }}>
        <div style={{ maxWidth: "800px" }}>
          {eyebrow && (
            <div className="eyebrow eyebrow-dark" style={{ marginBottom: "1rem" }}>
              {eyebrow}
            </div>
          )}
          <h1 style={{ color: "var(--text-on-dark)", marginBottom: "1.5rem", lineHeight: "1.1" }}>
            {title}
          </h1>
          <p
            className="lead lead-dark"
            style={{ fontSize: "1.25rem", maxWidth: "680px", marginBottom: "2.5rem" }}
          >
            {subtitle}
          </p>
          <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            {primaryCTA && (
              <CTA to={primaryCTA.to} variant="primary" size="lg">
                {primaryCTA.label}
              </CTA>
            )}
            {secondaryCTA && (
              <CTA to={secondaryCTA.to} variant="ghost-light" size="lg">
                {secondaryCTA.label}
              </CTA>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
